import UploadS3 from './UploadS3';

export default UploadS3;
